import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Link } from "react-router-dom";
import axios from "axios";
import _ from "lodash";
import { AppProvider } from "@shopify/polaris";
import "@shopify/polaris/build/esm/styles.css";
import ltTranslations from "./polaris-lt.json";
import store from "./configureStore.ts";
import "./i18n";
import "./index.css";
import App from "./App.tsx";
import "utils/datadogConfig";
import { startVersionCheck } from "utils/versionCheck";
import {
  isDisabledCompanyOfThisPage,
  leaveCompany,
} from "features/auth/access-lost";

axios.interceptors.request.use(
  (config) => {
    const next = { ...config, withCredentials: true };
    if (typeof window !== "undefined" && window.location && window.location.pathname) {
      next.headers = next.headers || {};
      next.headers["X-Client-Route"] = window.location.pathname;
    }
    return next;
  },
  Promise.reject
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isDisabledCompanyOfThisPage(error)) {
      leaveCompany("removed");
    }
    if (
      _.get(error, "response.status") === 403 &&
      _.get(window, "location.pathname") !== "/login" &&
      _.get(window, "location.pathname") !== "/signup"
    ) {
      // window.location = '/auth/login';
    }
    return Promise.reject(error);
  }
);

// eslint-disable-next-line react/prop-types
function AdapterLink({ url, ...rest }) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Link to={url} {...rest} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <Router>
      <AppProvider i18n={ltTranslations} linkComponent={AdapterLink}>
        <App />
      </AppProvider>
    </Router>
  </Provider>
);

// Start version check to automatically reload on new builds
startVersionCheck();
